function Error() {
  return (
    <div class="wrapper" style={{ margin: "0 auto", maxWidth: "80rem" }}>
      <h1 class="">Oops...</h1>
      <p style={{ textAlign: "center" }}>An unexpected error occured.</p>
    </div>
  )
}

export default Error